module.exports = __webpack_public_path__ + "img/ip-img.48cf0c8f.png";